import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export interface LogoResponse {
  key: string;
  name: string;
  type?: string;
  logoURI?: string | null;
}

@Injectable({ providedIn: 'root' })
export class BridgeApiService {
  constructor(private http: HttpClient) {}

  getBridgeLogo(key: string): Observable<string | null> {
    return this.http
      .get<LogoResponse>(`${environment.backendUrl}/tools/logo/${key}`)
      .pipe(
        map(res => res.logoURI ?? null),
        catchError(() => of(null))
      );
  }

  getQuote(
    sellToken: string,
    buyToken: string,
    sellAmount: string,
    taker: string,
    fromChainId: number,
    toChainId: number,
    slippage: number = 100,
    bridge: string = 'openocean'
  ): Observable<any> {
    const params = new HttpParams()
      .set('sellToken', sellToken)
      .set('buyToken', buyToken)
      .set('sellAmount', sellAmount)
      .set('taker', taker)
      .set('fromChainId', fromChainId.toString())
      .set('toChainId', toChainId.toString())
      .set('slippage', slippage.toString())
      .set('bridge', bridge);

    const headers = new HttpHeaders({
      'ngrok-skip-browser-warning': '1'
    });

    const url = `${environment.backendUrl}/bridge/quote`;
    return this.http.get<any>(url, { params, headers });
  }
}
